import React from "react";
import Sri from "../../assests1/Management/srinath1.jpg";
import Sakthi from "../../assests1/Management/sakthivel1.png";
import Shanthani from "../../assests1/Management/shanthini.jpg";
import Vicky from "../../assests1/Management/VIGNESH-MURUGAN.jpg";

const Management = ({ onBack }) => {
  const members = [
    {
      name: "Dr. Midthe Vijayaragavan Srinath",
      img: Sri,
      description: `
        Dr. Srinath brings over two decades of experience in teaching undergraduate and postgraduate programs across various institutions.He holds a B.Sc. in Physics, an MCA, and a Ph.D. in Computer Applications from the University of Madras. 
        His expertise spans instructional design, technical education, and e-learning, having served as a consultant to universities and government bodies including Tamil Nadu Open University, IGNOU, NIMI, and the Ministry of Human Resource Development.

        Srinath has chaired academic committees focused on NBA, NAAC, and AICTE accreditation for engineering and arts & science colleges.He has mentored more than twenty research scholars in areas such as software engineering, web engineering, and instructional design. With over 100 published papers in conferences and journals, his contributions to academia are widely recognized.

        He joined the board of Sankara in 2017 and continues to guide strategic initiatives. Outside of work, Srinath enjoys traveling and shares his knowledge as a part-time lecturer at various colleges.
      `,
    },
    {
      name: "Sakthivel Selvamani",
      img: Sakthi,
      description: `
        Sakthivel Selvamani joined Sankara in 2007 as a Junior Programmer, soon after earning his Bachelor's Degree in Information Technology from Anna University. Over the years, Sakthi has grown into a seasoned developer and now leads product development across all software offerings. His strategic leadership as Solutions Director was instrumental in shaping Sankara’s flagship multi-channel contact center software.

        In 2020, Sakthi was appointed to the board in recognition of his long-standing dedication and significant contributions to the company’s growth.He also holds a Postgraduate Certification in Blockchain from Amity University, Uttar Pradesh, India, further expanding his expertise in emerging technologies.

        Sakthi is known for his hands-on approach, technical depth, and commitment to innovation. Outside of work, he enjoys playing cricket and shuttle badminton, reflecting his energetic and team-oriented spirit.
      `,
    },
    {
      name: "Shanthini Anand",
      img: Shanthani,
      description: `
        Shanthini is a dynamic professional with over 15 years of experience across the banking and software industries. She holds a Bachelor's degree in Computer Science Engineering and an MBA in Operations and Management, blending technical expertise with strategic business insight. Her career spans software testing, customer relationship management, and product support.

        Known for her analytical mindset and ability to thrive in fast-paced environments, she brings precision, innovation, and a collaborative spirit to every challenge. Her leadership and commitment to continuous learning have made her a trusted mentor and dependable team player.

        Outside of work, she is an avid baker who enjoys crafting creative recipes and watching heartwarming films. Shanthini joined the Board of Sankara in 2022 and continues to inspire with her integrity and dedication.
      `,
    },
    {
      name: "Vignesh Murugan",
      img: Vicky,
      description: `
        Vignesh Murugan holds a Bachelor of Engineering in Computer Science and Engineering and has been with Sankara Software Services Pvt. Ltd. since June 2018. He currently serves as Project Manager and Lead for software products, overseeing end-to-end execution, design strategy, and team collaboration.

        Vignesh is known for his strategic thinking and ability to foster high-performing teams. Outside of his professional role, he is passionate about agriculture and exploring ways to integrate technology into sustainable farming.

        His dedication to innovation and community-focused solutions makes him a valuable contributor to Sankara’s mission.
      `,
    },
  ];

 

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0a0f1c] via-[#0f1629] to-[#0a0f1c] py-16 mt-6 relative">
    
      <div
        className="absolute inset-0 opacity-30 pointer-events-none"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%239C92AC' fill-opacity='0.03'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          backgroundRepeat: "repeat",
        }}
      ></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
      
        <div className="flex flex-col sm:flex-row justify-between items-center mb-16 gap-4">
          {onBack && (
            <button
              onClick={onBack}
              className="group flex items-center gap-2 px-5 py-2.5 rounded-full bg-white/5 backdrop-blur-sm border border-white/10 text-white/80 hover:text-white hover:bg-white/10 hover:border-white/20 transition-all duration-300"
            >
              <svg
                className="w-5 h-5 transform group-hover:-translate-x-1 transition-transform"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10 19l-7-7m0 0l7-7m-7 7h18"
                />
              </svg>
              <span>Back</span>
            </button>
          )}
          <div className="text-center sm:text-right flex-1">
            <h1 className="text-3xl md:text-4xl font-bold text-center text-white">
              Management of Sankara Software Services
            </h1>
          </div>
        </div>

       
        <div className="space-y-20">
          {members.map((m, idx) => {
            const isReverse = idx % 2 !== 0;

            return (
              <div
                key={idx}
                className="group"
                style={{
                  animation: `fadeInUp 0.8s cubic-bezier(0.2, 0.9, 0.4, 1.1) forwards`,
                  animationDelay: `${idx * 0.2}s`,
                  opacity: 0,
                }}
              >
                <div
                  className={`flex flex-col ${idx % 2 === 0 ? "lg:flex-row" : "lg:flex-row-reverse"} gap-12 items-center`}
                >
                 
                  <div className="w-full lg:w-1/2">
                    <div className="relative max-w-md mx-auto lg:mx-0">
                     
                      <div className="absolute -inset-3 bg-gradient-to-r from-indigo-500/20 to-purple-500/20 rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-500"></div>

                      <div className="relative bg-gradient-to-br from-indigo-500/10 to-purple-500/10 backdrop-blur-sm rounded-2xl p-2 border border-white/10">
                        <div className="relative overflow-hidden rounded-xl bg-[#0a0f1c]">
                          <img
                            src={m.img}
                            alt={m.name}
                            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                            style={{
                              height: "550px",
                              objectPosition: "top center",
                            }}
                          />
                         
                          <div className="absolute inset-0 bg-gradient-to-t from-[#0a0f1c] via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                        </div>
                      </div>
                    </div>
                  </div>

                 
                  <div className="w-full lg:w-1/2">
                    <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 shadow-lg border border-white/10 hover:border-indigo-500/30 transition-all duration-300">
                      <h2 className="text-2xl md:text-3xl font-semibold text-white mt-1 mb-3">
                        {m.name}
                      </h2>
                      <p className="text-white text-md leading-relaxed whitespace-pre-line">
                        {m.description}
                      </p>
                    </div>
                  </div>
                </div>

              
                {idx !== members.length - 1 && (
                  <div className="flex justify-center mt-12">
                    <div className="w-24 h-px bg-gradient-to-r from-transparent via-indigo-500/50 to-transparent"></div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

     
      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(40px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default Management;
